import React from 'react'
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from '@mui/material'
import moment from 'moment'
import {IGhostDevice} from '@containers/equipment/mikrotik/types'

interface IProps {
	devices: IGhostDevice[]
}

const renderDate = (value: string) => {
	if (!value) {
		return <Typography variant="body2" color="text.disabled">—</Typography>
	}
	return (
		<Tooltip title={moment(value).format('DD.MM.YYYY HH:mm:ss')}>
			<Typography variant="body2" noWrap>
				{moment(value).format('DD.MM.YYYY HH:mm')}
			</Typography>
		</Tooltip>
	)
}

export const ConnectedMikrotikTable = ({devices}: IProps) => {
	if (!devices?.length) {
		return null
	}

	return (
		<TableContainer>
			<Table size="small" stickyHeader>
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>IMEI</TableCell>
						<TableCell>IP</TableCell>
						<TableCell>Перше з'єднання</TableCell>
						<TableCell>Останнє з'єднання</TableCell>
						<TableCell align="right">Кількість</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{devices.map((device) => (
						<TableRow key={device.id} hover>
							<TableCell>{device.id}</TableCell>
							<TableCell>
								<Typography variant="body2" fontWeight={600} noWrap>
									{device.imei}
								</Typography>
							</TableCell>
							<TableCell>{device.ip}</TableCell>
							<TableCell>{renderDate(device.firstConnect)}</TableCell>
							<TableCell>{renderDate(device.lastConnect)}</TableCell>
							<TableCell align="right">{device.count?.toLocaleString()}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

export default ConnectedMikrotikTable
